module.exports = __webpack_public_path__ + "img/promises_icon_02.c3a550f5.png";